// UnmetDemandTransportSystemSection.js
import React from 'react';
import { BaseUnmetDemandSystemSection } from './BaseUnmetDemandSystemSection';
import DirectionsTransitIcon from '@mui/icons-material/DirectionsTransit';
import BusinessIcon from '@mui/icons-material/Business';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import SecurityIcon from '@mui/icons-material/Security';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import SchoolIcon from '@mui/icons-material/School';
import TrainIcon from '@mui/icons-material/Train';
import GavelIcon from '@mui/icons-material/Gavel';
import { useTheme } from '@mui/material/styles';

// Icon mapping for different system types
const getSystemIcon = (systemKey) => {
    const iconMap = {
        'court': GavelIcon, 'fire': LocalFireDepartmentIcon, 'food': RestaurantIcon,
        'harbour': DirectionsBoatIcon, 'health': LocalHospitalIcon, 'military': SecurityIcon,
        'office': BusinessIcon, 'pharmacy': LocalPharmacyIcon, 'police': LocalPoliceIcon,
        'school': SchoolIcon, 'train': TrainIcon
    };
    return iconMap[systemKey] || DirectionsTransitIcon;
};

const getSystemColor = (systemKey, theme) => {
    const colorMap = {
        'court': theme.palette.secondary.main, 'fire': theme.palette.error.main,
        'food': theme.palette.success.main, 'harbour': theme.palette.info.main,
        'health': theme.palette.error.light, 'military': theme.palette.grey[700],
        'office': theme.palette.primary.main, 'pharmacy': theme.palette.success.dark,
        'police': theme.palette.primary.dark, 'school': theme.palette.warning.main,
        'train': theme.palette.info.dark
    };
    return colorMap[systemKey] || theme.palette.warning.main;
};

// --- MODIFIED: Added scenarioName and hazardLabel to props ---
export const UnmetDemandTransportSystemSection = ({
    analysisData,
    nameMap,
    systemLabel,
    systemKey,
    floodData,
    scenarioId,
    llmSummaries,
    scenarioName,
    hazardLabel
}) => {
    const theme = useTheme();
    const SystemIcon = getSystemIcon(systemKey);
    const systemColor = getSystemColor(systemKey, theme);
    
    const getSectionTitle = () => {
        return `${systemLabel} infrastructures with cascading risks`;
    };

    return (
        <BaseUnmetDemandSystemSection
            analysisData={analysisData}
            nameMap={nameMap}
            systemKey={systemKey}
            sectionTitle={getSectionTitle()}
            systemIcon={SystemIcon}
            systemColor={systemColor}
            floodData={floodData}
            scenarioId={scenarioId}
            // --- MODIFIED: Pass the new props down ---
            scenarioName={scenarioName}
            hazardLabel={hazardLabel}
            // --- FIXED: Changed prop name from llmSummary to the expected llmInsights ---
            llmInsights={llmSummaries?.systems?.[systemKey]}
        />
    );
};